import 'css-chunk:src/event-selection/EventSelection.module.scss';export default {
  "top": "_top_19ojw_1",
  "actionButtons": "_actionButtons_19ojw_14",
  "rememberSelection": "_rememberSelection_19ojw_23",
  "rememberSelectionLabel": "_rememberSelectionLabel_19ojw_36",
  "eventGroupList": "_eventGroupList_19ojw_40",
  "loader": "_loader_19ojw_49",
  "loaderBar": "_loaderBar_19ojw_55",
  "borealis-bar": "_borealis-bar_19ojw_1"
};